function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 美化请求参数
 * @param data 数据
 * @param defaultValueMap 默认数据
 * @deprecated 请使用浏览器标准 https://developer.mozilla.org/zh-CN/docs/Web/API/URL_API
 */
export function prettyQuery(data) {
  var defaultValueMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var defaultMap = _objectSpread({}, defaultValueMap);
  return Object.keys(data).reduce(function (map, key) {
    var val = data[key];
    var str = (val + '').trim();
    var def = key in defaultMap ? defaultMap[key] : null;
    if (val !== null && str !== '' && str !== def) {
      map[key] = str;
    }
    return map;
  }, {});
}
var rUrlParams = /^([^?]*)(?:\?)?(.*)$/;
var decode = function decode(s) {
  return s !== null ? decodeURIComponent(s).trim() : null;
};
var map2Param = function map2Param(map) {
  var list = Object.entries(map).map(function (it) {
    // 过滤掉 null，但不过滤空串，以便 k1=v1&onlykey&k2=v2
    var _it$map = it.map(decode),
      _it$map2 = _slicedToArray(_it$map, 2),
      key = _it$map2[0],
      val = _it$map2[1];
    return key !== '' && val !== null ? [key, val].join('=').replace(/=$/, '') : null;
  });
  return list.join('&');
};
var param2Map = function param2Map(str) {
  return str.split('&').reduce(function (ret, it) {
    var s = it.trim();
    if (s) {
      var _s$split$map = s.split('=').map(decode),
        _s$split$map2 = _slicedToArray(_s$split$map, 2),
        key = _s$split$map2[0],
        val = _s$split$map2[1];
      // 保留空串，以免丢掉不带值的 KEY
      ret[key] = val || '';
    }
    return ret;
  }, {});
};
var decodeParams = function decodeParams(obj) {
  var newObj = {};
  Object.entries(obj).forEach(function (it) {
    var _it$map3 = it.map(decode),
      _it$map4 = _slicedToArray(_it$map3, 2),
      key = _it$map4[0],
      val = _it$map4[1];
    newObj[key] = val;
  });
  return newObj;
};

/**
 * 构建新的 URL
 * @param url 现有的 URL，可以带有 query 参数
 * @param query query 字符串或对象，去除某个参数，可以使用 { some: null }
 * @deprecated 请使用浏览器标准 https://developer.mozilla.org/zh-CN/docs/Web/API/URL_API
 */
export function buildUrl(url, query) {
  var durl = decodeURI(url);
  var params = (typeof query === 'string' ? param2Map : decodeParams)(query);
  var _ref = durl.match(rUrlParams) || [],
    _ref2 = _slicedToArray(_ref, 3),
    _ref2$ = _ref2[1],
    prefix = _ref2$ === void 0 ? '' : _ref2$,
    _ref2$2 = _ref2[2],
    oldQuery = _ref2$2 === void 0 ? '' : _ref2$2;
  var newParams = _objectSpread(_objectSpread({}, param2Map(oldQuery)), params);
  var newQuery = map2Param(newParams);
  return encodeURI((prefix + '?' + newQuery).replace(/\?$/, ''));
}
var getParams = function getParams() {
  return param2Map(location.search.replace(/^\?/, ''));
};

/**
 * 获取 url 参数
 * @param name 参数名，不传则获取全部
 * @param defaultValue 参数默认值
 * @deprecated 请使用浏览器标准 https://developer.mozilla.org/zh-CN/docs/Web/API/URL_API
 */
export function urlParam(name) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var params = getParams();
  return name ? name in params ? params[name] : defaultValue : params;
}